import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import InternalUserService from '../services/InternalUserService';
import SubcontractorService from '../services/SubcontractorService';
import ActionLink from '../components/ActionLink';
import InputAutocompleteComponent from '../components/inputs/InputAutocompleteComponent';
import InputMultiSelectComponent from '../components/inputs/InputMultiSelectComponent';
import AccountService from '../services/AccountService';

class UserEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new InternalUserService());
        this.state = {
            elementId: props.elementId,
            element: {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                role: undefined,
                status: {enumValue: 'ACTIVE', enumLabel: 'Aktywny'},
            },
            subcontractors: [],
            viewMode: this.props.viewMode,
        };
        this.subcontractorService = new SubcontractorService();
        this.accountService = new AccountService();
        this.searchSubcontractors = this.searchSubcontractors.bind(this);
    }

    searchSubcontractors(query) {
        this.subcontractorService
            .getList({firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true, status: { enumValue: 'ACTIVE' }})
            .then((subcontractors) => {
                this.setState({subcontractors: subcontractors.content});
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy pracowników');
            });
    }

    initBeforeSetElement() {        
        super.initBeforeSetElement();        
        if (!this.props.isFromProfile) {
            this.subcontractorService
                .getList({ firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
                .then((subcontractors) => {
                    this.setState({ subcontractors: subcontractors.content });
                })
                .catch(() => {
                    this.showErrorMessage('Nie udało się pobrać listy klientów');
                });
        }
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('internaluser.addButton') : t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('internaluser.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                            ? `${t('internaluser.editHeader')}`
                            : this.state.viewMode === 'DELETE'
                            ? `${t('internaluser.deleteHeader')}`
                            : null}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    
    getAddSucces() {
        const {t} = this.props;
        return t('internaluser.addUserSuccess');
    }

    getUpdateSucces() {
        const {t} = this.props;
        return this.props.isFromProfile ? 'Zaktualizowano profil' : t('internaluser.updateUserSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        const fromProfile =  this.props.isFromProfile;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            } else {
                if (fromProfile) {
                    this.accountService
                    .updateMyAccount(element.id, element.firstName, element.lastName)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });

                } else {
                    this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
                }                
            }
        }
    }

    renderDetails() {
        const {t} = this.props;
        
        const roleViewMode = (this.authService.isUserInRole('ROLE_USER_EDIT') && this.isUserInRole('ROLE_USER_TYPE_ADMIN')) ? 'EDIT' : 'VIEW';
        return this.state.viewMode === 'DELETE' ? (
            <DivContainer>
                <label id={`delete-driver-label-id`} className='p-label' htmlFor={'delete-driver'} style={{width: '100%'}}>
                    {t('details.deleteConfirmation')}
                </label>
                <span
                    aria-label={t('details.deleteConfirmation')}
                    aria-labelledby={`delete-user--label-id`}
                    className={`p-inputtext-view icon_text element-to-remove`}
                >
                    {this.state.element.firstName} {this.state.element.lastName}
                </span>
            </DivContainer>
        ) : (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputDropdownComponent
                        id='status'
                        name='status'
                        label={t('internaluser.dialog.status')}
                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.element.status}
                        validator={this.validator}
                        options={this.state.statusOptions}
                        onChange={null}
                        viewMode={'VIEW'}
                        optionLabel='label'
                        dataKey='enumValue'
                        validators='not_required'
                        rendered={this.props.viewMode !== 'NEW'}
                        valueView={this.state.element.status ? this.state.element.status.label : ''}
                    />
                </DivContainer>
                <DivContainer colClass='row mt-4'>
                    <InputTextComponent
                        id='firstName'
                        name='firstName'
                        label={t('internaluser.dialog.firstName')}
                        colClass='col-md-6'
                        value={this.state.element.firstName}
                        validator={this.validator}
                        validators='required|alpha_space_dash|max:50'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                    />
                    <InputTextComponent
                        id='lastName'
                        name='lastName'
                        label={t('internaluser.dialog.lastName')}
                        colClass='col-md-6'
                        value={this.state.element.lastName}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                    />
                    <InputTextComponent
                        id='email'
                        name='email'
                        label={t('internaluser.dialog.email')}
                        colClass='col-md-6'
                        value={this.state.element.email}
                        validator={this.validator}
                        validators='required|email'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode === 'NEW' ? 'EDIT' : 'VIEW'}
                        //keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                    />{' '}
                    <InputMultiSelectComponent
                        id='roles'
                        name='roles'
                        label={t('internaluser.dialog.role')}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.element.roles}
                        validator={this.validator}
                        options={this.props.roles}
                        onChange={this.handleChange}
                        viewMode={roleViewMode}
                        optionLabel='name'
                        dataKey='id'
                        validators={`required`}
                        showClear
                        disabled={this.props.UserEditDialog}
                        rendered = {!this.props.isFromProfile}
                    />
                </DivContainer>
                <DivContainer colClass='row'>
                    <div className='col-md-10 mt-3'>
                        <InputAutocompleteComponent
                            id={`subcontractor`}
                            label='Subkontraktor'
                            name='subcontractor'
                            value={this.state.element.subcontractor}
                            dropdown
                            forceSelection
                            viewMode={this.props.viewMode}
                            validator={this.validator}
                            validators='not_required'
                            showLabel={false}
                            onChange={this.handleChange}
                            insideTable
                            disabled={this.props.isFromProfile}
                            filteredList={this.state.subcontractors}
                            filterList={(query) => this.searchSubcontractors(query)}
                            field='name'
                            minLength={3}
                            placeholder={'Znajdź podwykonawce'}
                        />
                    </div>
                    <div className='col-md-2 mt-4'>
                        <ActionLink
                            iconName='mdi-delete'
                            iconSide='left'
                            iconSize='icon-large'
                            rendered={this.props.isFromProfile ? false : this.props.viewMode !== 'VIEW'}
                            handleClick={() => {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        subcontractor: undefined,
                                    },
                                }));
                            }}
                            variant='blue'
                            className='edit-blue-link'
                            key={'delete-button'}
                        />
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }
}

UserEditDialog.defaultProps = {
    id: 'user-edit-dialog',
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    isFromProfile: false,
    stationId: undefined,
};

UserEditDialog.propTypes = {
    id: PropTypes.string,
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    isFromProfile: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    roles: PropTypes.object,
};

export default withTranslation()(UserEditDialog);
